export default class ValidationHelper {
  public static isValidValue(value: string|undefined|number|null|boolean): boolean {
    return value === undefined || value === null || value === '' || value === false;
  }
}
